import React from "react";
import SlidingCarousel from "../SlidingCarousel/SlidingCarousel";
import "./TryCatchInC.css" 


// By extending the React.Component class, TextArea inherits functionality from it
class TryCatchInC extends React.Component 
{

    constructor(props)
    {

    	/* We MUST call the parent class contructor and send it the props object */
    	super(props);
    }

    render()
    {
        return(
        <div className="TryCatchDiv">
        <h5>Try Catch in C</h5>

        <p>One of the tenets of structured programming is that there should
            be only one point of exit in a function or procedure.</p>

        <p>While many coding standards allow for early exits based upon 
           input parameter checking, exits in the body of functions or 
           procedures are pretty much universally panned.</p>

        <p> This often gives rise to code that has levels and levels of 
            if statements like the following code snippet:</p>
        
        <p><i>Note:  The following code snippet can also be found 
            at <a href={"https://gist.github.com/charlesroberts442/2b3d42c5c52804cda9a216d9788af495"} 
            target={"_blank"}>one of my GitHubGist code snippets.</a></i></p>
        
        <pre>
            <code>
            <p className="LineNumber"> 1    </p>
            <p className="CodeLine">{"int iStatus = 0;"}</p>
            <br />

            <p className="LineNumber"> 2    </p>
            <p className="CodeLine">{"iStatus = FunctionOne()"}</p>
            <br />
            
            <p className="LineNumber"> 3    </p>
            <p className="CodeLine">{"if(iStatus == 0)"}</p>
            <br />

            <p className="LineNumber"> 4    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            
            <p className="LineNumber"> 5        </p>
                <p className="CodeLine">{"iStatus = FunctionTwo()"}</p>
            <br />

            <p className="LineNumber"> 6        </p>
            <p className="CodeLine">{"if(iStatus == 0)"}</p>
            <br />

            <p className="LineNumber"> 7        </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber"> 8            </p>
                <p className="CodeLine">{"iStatus = FunctionThree()"}</p>
            <br />

            <p className="LineNumber"> 9            </p>
            <p className="CodeLine">{"if(iStatus == 0)"}</p>
            <br />

            <p className="LineNumber">10            </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">11                </p>
                <p className="CodeLine">{"iStatus = FunctionFour()"}</p>
            <br />

            <p className="LineNumber">12                </p>
            <p className="CodeLine">{"if(iStatus == 0)"}</p>
            <br />

            <p className="LineNumber">13                </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">14                    </p>
                <p className="CodeLine">{"iStatus = FunctionFive()"}</p>
            <br />

            <p className="LineNumber">15                    </p>
            <p className="CodeLine">{"if(iStatus == 0)"}</p>
            <br />

            <p className="LineNumber">16                    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

                <p className="LineNumber">17                        </p>
            <p className="CodeLine">{"iStatus = FunctionSix();"}</p>
            <br />

            <p className="LineNumber">18                    </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">19                    </p>
            <p className="CodeLine">{"else"}</p>
            <br />

                <p className="LineNumber">20                    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

                <p className="LineNumber">21                        </p>
            <p className="CodeLine">{"// Deal with the error from function five"}</p>
            <br />

                <p className="LineNumber">22                    </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">23                </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">24                </p>
            <p className="CodeLine">{"else"}</p>
            <br />

            <p className="LineNumber">25                </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">26                    </p>
            <p className="CodeLine">{"// Deal with the error from function four"}</p>
            <br />

            <p className="LineNumber">27                </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">28            </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">29            </p>
            <p className="CodeLine">{"else"}</p>
            <br />

            <p className="LineNumber">30            </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">31                </p>
            <p className="CodeLine">{"// Deal with the error from function three"}</p>
            <br />

            <p className="LineNumber">32            </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">33        </p>
            <p className="CodeLine">{"else"}</p>
            <br />

            <p className="LineNumber">34        </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">35            </p>
            <p className="CodeLine">{"// Deal with the error from function two"}</p>
            <br />

            <p className="LineNumber">36        </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">37     </p>
            <p className="CodeLine">{"else"}</p>
            <br />

            <p className="LineNumber">38    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">39        </p>
            <p className="CodeLine">{"// Deal with the error from function one"}</p>
            <br />

            <p className="LineNumber">40    </p>
            <p className="CodeLine">{"}"}</p>
            <br />
                
            </code>
        </pre>

        <p>Code like the block above is ugly, it's hard to write, it's hard to 
            understand, and it inches its way inexorably to the right.</p>


        <p>One afternoon about ten years ago, I was writing a function and 
            thought there had to be a better solution.  Here is how do I 
            do error checking in structured code now:</p>

        <p><i>Note:  The following code snippet can also be found 
            at <a href={"https://gist.github.com/charlesroberts442/b754d411b7603c94bc0aeb8ebb188e16"} 
            target={"_blank"}>another one of my GitHubGist code snippets.</a></i></p>

        <pre>
            <code>
            <p className="LineNumber"> 1    </p>
            <p className="CodeLine">{"int iStatus = 0;"}</p>
            <br />

            <p className="LineNumber"> 2    </p>
            <p className="CodeLine">{"iStatus = FunctionOne()"}</p>
            <br />
            
            <p className="LineNumber"> 3    </p>
            <p className="CodeLine">{"if(iStatus != 0)"}</p>
            <br />

            <p className="LineNumber"> 4    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber"> 5        </p>
            <p className="CodeLine">{"// Try to recover from the error returned"}</p>
            <br />

            <p className="LineNumber"> 6        </p>
            <p className="CodeLine">{"// by FunctionOne.  If recovery is possible,"}</p>
            <br />

            <p className="LineNumber"> 7        </p>
            <p className="CodeLine">{"// reset iStatus to zero.  If recovery is "}</p>
            <br />

            <p className="LineNumber"> 8        </p>
            <p className="CodeLine">{"// not possible, let iStatus stay an error condition. "}</p>
            <br />

            <p className="LineNumber"> 9    </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">10    </p>
            <p className="CodeLine">{" "}</p>
            <br />

            <p className="LineNumber">11    </p>
            <p className="CodeLine">{"if(iStatus == 0)"}</p>
            <br />

            <p className="LineNumber">12    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">13        </p>
            <p className="CodeLine">{"iStatus = FunctionTwo()"}</p>
            <br />

            <p className="LineNumber">14        </p>
            <p className="CodeLine">{"if(iStatus != 0)"}</p>
            <br />

            <p className="LineNumber">15        </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">16            </p>
            <p className="CodeLine">{"// Try to recover from the error returned"}</p>
            <br />

            <p className="LineNumber">17            </p>
            <p className="CodeLine">{"// by FunctionTwo.  If recovery is possible,"}</p>
            <br />

            <p className="LineNumber">18            </p>
            <p className="CodeLine">{"// reset iStatus to zero.  If recovery is "}</p>
            <br />

            <p className="LineNumber">19            </p>
            <p className="CodeLine">{"// not possible, let iStatus stay an error condition. "}</p>
            <br />

            <p className="LineNumber">20        </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">21    </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">22    </p>
            <p className="CodeLine">{" "}</p>
            <br />

            <p className="LineNumber">23    </p>
            <p className="CodeLine">{"if(iStatus == 0)"}</p>
            <br />

            <p className="LineNumber">24    </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">25        </p>
            <p className="CodeLine">{"iStatus = FunctionThree()"}</p>
            <br />

            <p className="LineNumber">26        </p>
            <p className="CodeLine">{"if(iStatus != 0)"}</p>
            <br />

            <p className="LineNumber">27        </p>
            <p className="CodeLine">{"{"}</p>
            <br />

            <p className="LineNumber">28            </p>
            <p className="CodeLine">{"// Try to recover from the error returned"}</p>
            <br />

            <p className="LineNumber">29            </p>
            <p className="CodeLine">{"// by FunctionThree.  If recovery is possible,"}</p>
            <br />

            <p className="LineNumber">30            </p>
            <p className="CodeLine">{"// reset iStatus to zero.  If recovery is "}</p>
            <br />

            <p className="LineNumber">31            </p>
            <p className="CodeLine">{"// not possible, let iStatus stay an error condition. "}</p>
            <br />

            <p className="LineNumber">32        </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">33    </p>
            <p className="CodeLine">{"}"}</p>
            <br />

            <p className="LineNumber">34    </p>
            <p className="CodeLine">{"... "}</p>
            <br />

            

            </code>
        </pre>
        </div>
        );
    }

} // End of class  TryCatchInC

export default TryCatchInC;



// WEBPACK FOOTER //
// ./src/components/CppPatterns/TryCatchInC.js